<div class="text-center d-flex flex-column justify-content-between w-100">
  <h4 mat-dialog-title class="dialog-title"><strong>{{data.title}}</strong></h4>
  <div class="dialog-content" mat-dialog-content>
    <p>{{data.description}}</p>
  </div>
  <div mat-dialog-actions class="mat-dialog-actions">
    <button class="px-2 btn btn-light" mat-button mat-dialog-close (click)="onCancel()" cdkFocusInitial>{{data.closeButtonText}}</button>
    <button class="px-2 btn btn-flat" mat-button mat-dialog-close (click)="onConfirm()">{{data.confirmButtonText}}</button>
  </div>
</div>